import { useLingui } from '@lingui/react/macro';

import { FilterDate } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import { FilterDateValue } from '@/design_system/Filters/FiltersMenu/FilterDate';
import { DateRangeValue } from '@/design_system/InputDate/InputDateRange';
import IconCalendarEdit from '@/icons/CalendarEdit.svg';

import { useFilters } from '../FiltersState';
import { useDateOptions } from '../utils';

export const FiltersCreatedAt = () => {
  const { t } = useLingui();
  const {
    createdAt: { createdAt, setCreatedAt },
  } = useFilters();

  const baseCreatedAtOptions = useDateOptions();

  const toggleDate = (value: FilterDateValue, customValue?: DateRangeValue): void => {
    if (value === 'custom' && customValue) {
      setCreatedAt({ id: value, ...customValue });

      return;
    }

    const currentSelected = baseCreatedAtOptions.find((date) => date.id === value);

    if (currentSelected && currentSelected.value) {
      const { start, end } = currentSelected.value;

      setCreatedAt({ id: value, start, end });
    } else {
      setCreatedAt({ id: 'all', start: null, end: null });
    }
  };

  const { start, end } = createdAt;
  const customValue = createdAt.id === 'custom' && start && end ? { start, end } : undefined;

  return (
    <FilterDate
      icon={<IconCalendarEdit />}
      label={t({ id: 'requests.filters.createdAt.label', message: 'Creation date' })}
      value={createdAt.id}
      customValue={customValue}
      onChange={toggleDate}
    />
  );
};
